export const padZero = (str: string | number, len: number = 2) => {
  const zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
};
